import { render, staticRenderFns } from "./CoozzyCheckMarkIcon.vue?vue&type=template&id=0f074d9c&scoped=true"
import script from "./CoozzyCheckMarkIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyCheckMarkIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f074d9c",
  null
  
)

export default component.exports